<template>
  <div class="bg-white p-4 rounded-lg shadow mt-4">
    <div class="flex flex-row items-center justify-between">
      <div class="flex flex-row items-center">
        <div
          class="w-8 h-8 rounded-full flex items-center justify-center"
          :class="`bg-${circle_color}`"
        >
          <img class="w-icon h-icon" :src="icon" />
        </div>

        <span class="font-semibold ml-2" :class="`text-${text_color}`">
          {{ title }}
        </span>
      </div>

      <button
        v-if="dropdown"
        class="w-6 h-6 flex items-center justify-center"
        @click="toggle"
      >
        <img class="w-6 h-6" :src="is_open ? dropup_icon : dropdown_icon" />
      </button>
    </div>

    <transition name="fade">
      <div v-show="!dropdown || is_open" class="mt-2">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "BalanceGroupControl",

  props: {
    title: {
      type: String,
      default: "Savings",
    },
    icon: {
      type: String,
      default: () =>
        new URL("@/assets/icons/papsi_savings.svg", import.meta.url).href,
    },
    text_color: {
      type: String,
      default: "primary",
    },
    circle_color: {
      type: String,
      default: "primary-light",
    },
    dropdown: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      is_open: true,
      dropdown_icon: new URL(
        "@/assets/icons/papsi_dropdown.svg",
        import.meta.url,
      ).href,
      dropup_icon: new URL("@/assets/icons/papsi_dropup.svg", import.meta.url)
        .href,
    };
  },

  methods: {
    toggle() {
      this.is_open = !this.is_open;
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
